export { CompassStar, type CompassStarRender } from './CompassStar.js';
export { Wordmark } from './Wordmark.js';
export { Logo } from './Logo.js';

export const TAGLINE = 'Where money meets trust';
export const BRAND_NAME = 'NORVIX';
